import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Document } from '../../../../domain/documents.types'
import { Wrapper } from '../../globals'

interface ActionGroupButtonProps {
  document: Document
  downloadFunction: (...args: any[]) => void
  viewFunction: (...args: any[]) => void
  isDownloading: boolean
}

const IconButton = styled.button<{ isDownloading: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  color: white;
  &:hover {
    color: #85f6f4;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const ActionGroupButton: React.FC<ActionGroupButtonProps> = (props) => {
  const { document, downloadFunction, viewFunction, isDownloading } = props
  return (
    <Wrapper justifyContent="space-around" paddingTop="1.1rem">
      <IconButton 
        isDownloading={isDownloading} 
        onClick={() => isDownloading ? undefined : viewFunction(document)}
        disabled={isDownloading}
      >
        <FontAwesomeIcon icon="eye" size="sm" />
      </IconButton>
      <IconButton 
        isDownloading={isDownloading}
        onClick={() => isDownloading ? undefined : downloadFunction(document)}
        disabled={isDownloading}
      >
        <FontAwesomeIcon icon="download" size="sm" />
      </IconButton>
    </Wrapper>
  )
}

export default ActionGroupButton
